import produce from 'immer';

// UTILS
import { toSelect } from 'utils/genericFunctions';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, Assuntos } from './types';

export const INITIAL_STATE: Assuntos = {
	status: 0,
	data: [],
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): Assuntos {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ASSUNTOS_REQUEST: {
				break;
			}
			case Types.ASSUNTOS_SUCCESS: {
				draft.status = action.payload.status;

				if (action.payload.data) {
					const select = toSelect(action.payload.data, 'nome', 'id');
					draft.data = select;
				} else {
					draft.data = [];
				}

				break;
			}
			case Types.ASSUNTOS_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.ASSUNTOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
